<template lang="pug">
.preview-other-user-template-modal
  b-modal(v-model="_value" size="md" @ok="ok" title="安否確認" no-close-on-backdrop no-close-on-esc)
    .preview-other-user-template-modal-body
      .mb-3 安否確認の入力をお願いします。

      .confirm.mb-3(v-for="(confirm, index) in confirms" v-if="confirm.use == true")
        .confirm-header.d-flex.mb-2
          .confirm-title.mr-2 {{ confirm.label }}
          .confirm-require(v-if="confirm.required == true")
            b-badge(variant="danger") 必須

        .confirm.radio(v-if="confirm.inputType == 0" v-for="option in confirm.inputOptions.choices")
          b-form-radio(:name="'radio-' + index" :value="option.value") {{ option.label }}

        .confirm.text(v-if="confirm.inputType == 1")
          b-form-textarea(:placeholder="confirm.inputOptions.placeholder" rows="3" max-rows="6" :maxlength="confirm.inputOptions.maxLength")

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { UseId } from "@/pc/pages/safetyConfirm/OtherUserTemplateEdit.vue";

/**
 * ### 安否確認（施設関係者）プレビューモーダル
 */
@Component({})
export default class PreviewOtherUserTemplateModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 確認リスト */
  @Prop()
  confirms!: Array<UseId>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}

export enum QuestionType {
  UNKNOWN = "unknown",
  RADIO = "radio",
  CHECKBOX = "checkbox",
  TEXT = "text",
  TEXTAREA = "textarea"
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.preview-other-user-template-modal-body {
  .confirm-title {
    font-weight: bold;
    font-size: 18px;
  }
}
</style>
